import React from 'react';
import { CardExpiryElement } from '@stripe/react-stripe-js';

import { VpStripeInput } from '../..';

export const StripeCardExpireInput = () => {
  return (
    <VpStripeInput
      stripeElement={CardExpiryElement}
      options={{
        placeholder: 'Expiration Date'
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/stripe-elements/StripeCardExpireInput.jsx